import { ApiResponse } from 'app/shared/models';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';

import { EncripterService } from './encriptor.service';

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _encripterService = inject(EncripterService);
  private _currentToken: string;

  private get HEADER(): HttpHeaders {
    const storedToken = localStorage.getItem('passport');

    if (storedToken) {
      try {
        this._currentToken = this._encripterService.get(
          environment.appKey,
          storedToken
        );
      } catch (error) {
        this._currentToken = '';
      }
    }

    if (!this._currentToken) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + this._currentToken,
      });
    }
  }

  public post<T>(url: string, params?: any): Observable<T> {
    return this._httpClient
      .post<T>(environment.apiUrl + url, params, {
        headers: this.HEADER,
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  public postBinary<T>(
    url: string,
    body: Blob | ArrayBuffer,
    options?: { contentType?: string; params?: Record<string, string> }
  ): Observable<T> {
    const headers = this.HEADER.set(
      'Content-Type',
      options?.contentType || 'application/octet-stream'
    );

    return this._httpClient
      .post<T>(environment.apiUrl + url, body, {
        headers,
        params: options?.params,
      })
      .pipe(map((obj) => obj));
  }

  public postFile(url: string, params?: any): Observable<Blob> {
    return this._httpClient
      .post(environment.apiUrl + url, params, {
        headers: this.HEADER,
        responseType: 'blob',
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  public postFormData<T>(url: string, params?: any): Observable<T> {
    return this._httpClient
      .post<T>(environment.fileUploadUrl + url, params, {
        // headers: new HttpHeaders({
        //   "Content-Type": "multipart/form-data",
        // }),
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  public get<T>(url: string, params?: any): Observable<T> {
    return this._httpClient
      .get<T>(environment.apiUrl + url, {
        headers: this.HEADER,
        params,
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  public file(url: string, params?: any): Observable<any> {
    return this._httpClient.get(environment.apiUrl + url, {
      headers: this.HEADER,
      responseType: 'blob',
      params,
    });
  }

  public put<T>(url: string, params?: any): Observable<T> {
    return this._httpClient
      .put<T>(environment.apiUrl + url, params, {
        headers: this.HEADER,
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  public patch<T>(url: string, params?: any): Observable<T> {
    return this._httpClient
      .patch<T>(environment.apiUrl + url, params, {
        headers: this.HEADER,
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  public delete<T>(url: string): Observable<T> {
    return this._httpClient
      .delete<T>(environment.apiUrl + url, {
        headers: this.HEADER,
      })
      .pipe(
        map((obj) => {
          return obj;
        })
      );
  }

  protected catchError(msg: any): ApiResponse<null> {
    if (msg.error && msg.error.message && Array.isArray(msg.error.message)) {
      return new ApiResponse(false, null, msg.error.message);
    }

    if (
      msg.error &&
      msg.error.message &&
      typeof msg.error.message === 'string'
    ) {
      return new ApiResponse(false, null, [msg.error.message]);
    }

    if (msg.error && msg.error.error && typeof msg.error.error === 'string') {
      return new ApiResponse(false, null, [msg.error.error]);
    }

    return new ApiResponse(false, null, [
      'Ocorreu um erro ao efetuar a solicitação',
    ]);
  }
}
